import React, { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import SuperAdminSidebar from './SuperAdminSidebar';

/**
 * RoleBasedSidebar - Automatically renders the correct sidebar based on user role
 * 
 * Security Note: This component enforces role-based navigation:
 * - super_admin role -> SuperAdminSidebar (platform management)
 * - All other roles -> Sidebar (center-specific functionality)
 * 
 * This ensures complete separation between admin and super admin navigation
 */
const RoleBasedSidebar = ({ isOpen, onClose }) => {
  const { user } = useContext(AuthContext);

  // Security check: Ensure user exists
  if (!user) {
    console.warn('RoleBasedSidebar: No user context available');
    return null;
  }

  // Route to appropriate sidebar based on role
  if (user.role === 'super_admin') {
    return <SuperAdminSidebar isOpen={isOpen} onClose={onClose} />;
  }

  // All other roles use the standard sidebar
  return <Sidebar isOpen={isOpen} onClose={onClose} />;
};

export default RoleBasedSidebar;